import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { applyUpdate } from "@/components/VersionBanner";

// Shows a gentle "Neue Version verfügbar" toast when the service worker detects an update.
export default function UpdateToast() {
  const shown = useRef(false);
  useEffect(() => {
    const onUpdate = () => {
      if (shown.current || window.__updateBannerMounted) return;
      shown.current = true;
      toast("Neue Version verfügbar", {
        description: "Jetzt aktualisieren, um die neueste Version zu laden.",
        duration: Infinity,
        action: {
          label: "Aktualisieren",
          onClick: applyUpdate,
        },
      });
    };
    window.addEventListener("sw-update-available", onUpdate);
    return () => window.removeEventListener("sw-update-available", onUpdate);
  }, []);
  return null;
}
